import { factory, Flex, Box, DsmColor, Typography, omitText, Coachmark, NotificationDot } from '@kohler-dsm-library/kohler-core';
import { UserIcon, LocationIcon, FavoriteNavFilledIcon, FavoriteNavIcon } from '@kohler-dsm-library/kohler-icons';
import { clsx } from 'clsx';
import React from 'react';
import { LanguageMenu } from '../../../LanguageMenu/LanguageMenu.mjs';
import { LoginMenu } from '../../../LoginMenu/LoginMenu.mjs';
import { StoreMenu } from '../../../StoreMenu/StoreMenu.mjs';
import { LanguagePicker } from '../../../UtilityLinks/subcomponents/LanguagePicker/LanguagePicker.mjs';
import { getSanitizedLanguagePickerCTA } from '../../OverlayMenu.utils.mjs';
import classes from './UtilityBarMobile.module.css.mjs';

const omitFavoritesCTA = (favoritesCTA) => {
  const { isFilled = false, notificationDot, ...omitFavoritesCTA2 } = favoritesCTA;
  return { isFilled, notificationDot, omitFavoritesCTA: omitFavoritesCTA2 };
};
const UtilityBarMobile = factory((props, ref) => {
  const { utilityLinks, className, ...rest } = props;
  const {
    userCTA,
    locationPickerCTA,
    favoritesCTA,
    languagePicker,
    userName,
    isLoggedIn,
    utilityLinksMobile,
    menuType,
    storeMenu,
    loginMenu,
    languageMenu,
    setIsOpenMobileMenu,
    setMenuType,
    userCTAMobile
  } = utilityLinks || {};
  return /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.utilityBarOverlayMobile, className), ref, ...rest }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 15, paddingTop: 20, paddingBottom: 30 }, userCTA && !userCTAMobile && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      textColor: DsmColor.ContentPrimary,
      "aria-label": isLoggedIn ? "user sign in" : "profile",
      ...userCTA,
      onClick: (e) => {
        userCTA?.onClick?.(e);
      }
    },
    /* @__PURE__ */ React.createElement(Flex, { gap: 5, align: "center", component: "span" }, /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: true }), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: DsmColor.ContentPrimary }, userCTA.text ? userCTA.text : isLoggedIn && userName ? `Hi, ${userName}` : "Sign in / Create Account"))
  ), userCTAMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, !isLoggedIn && /* @__PURE__ */ React.createElement(Box, { textColor: DsmColor.ContentPrimary, className: classes.userCTAMobileWrapper }, /* @__PURE__ */ React.createElement(
    Flex,
    {
      gap: 5,
      align: "center",
      component: "button",
      type: "button",
      onClick: (e) => {
        const userCTAOnClick = userCTAMobile?.signInCTA?.onClick;
        if (!userCTAOnClick) {
          userCTA?.onClick?.(e);
        } else {
          userCTAOnClick(e);
        }
      },
      ...omitText(userCTAMobile.signInCTA)
    },
    /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: true }),
    /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "div", textColor: DsmColor.ContentPrimary }, userCTAMobile.signInCTA.text ? userCTAMobile.signInCTA.text : "Sign in ")
  ), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: DsmColor.ContentPrimary }, "/"), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "navigation-s",
      component: "button",
      type: "button",
      textColor: DsmColor.ContentPrimary,
      onClick: (e) => {
        const userCTAOnClick = userCTAMobile?.signUpCTA?.onClick;
        if (!userCTAOnClick) {
          userCTA?.onClick?.(e);
        } else {
          userCTAOnClick(e);
        }
      },
      ...omitText(userCTAMobile.signUpCTA)
    },
    userCTAMobile.signUpCTA.text ? userCTAMobile.signUpCTA.text : "Create Account"
  )), isLoggedIn && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      textColor: DsmColor.ContentPrimary,
      ...userCTAMobile.accountCTA,
      onClick: (e) => {
        const userCTAOnClick = userCTAMobile?.accountCTA?.onClick;
        if (!userCTAOnClick) {
          userCTA?.onClick?.(e);
        } else {
          userCTAOnClick(e);
        }
      }
    },
    /* @__PURE__ */ React.createElement(Flex, { gap: 5, align: "center", component: "span" }, /* @__PURE__ */ React.createElement(UserIcon, { withBoundingBox: true }), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: DsmColor.ContentPrimary }, userCTAMobile.accountCTA.text ? userCTAMobile.accountCTA.text : `Hi, ${userName}`))
  ), menuType && loginMenu && /* @__PURE__ */ React.createElement(Box, { display: menuType !== "user" ? "none" : void 0, className: classes.menuPositionWrapper }, /* @__PURE__ */ React.createElement(LoginMenu, { ...loginMenu, setMenuType, setIsOpenMobileMenu }))), utilityLinksMobile && utilityLinksMobile.length > 0 && utilityLinksMobile.map((utilityLink) => {
    const { icon, ...linkProps } = utilityLink;
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        key: utilityLink.text,
        component: "a",
        textColor: DsmColor.ContentPrimary,
        ...omitText(linkProps),
        className: classes.utilityLink
      },
      /* @__PURE__ */ React.createElement(Flex, { gap: 5, align: "center", component: "span" }, icon, /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: DsmColor.ContentPrimary }, utilityLink.text))
    );
  }), locationPickerCTA && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Flex,
    {
      gap: 5,
      align: "center",
      component: "button",
      ...locationPickerCTA,
      onClick: (e) => {
        locationPickerCTA?.onClick?.(e);
      }
    },
    /* @__PURE__ */ React.createElement(LocationIcon, { withBoundingBox: true }),
    /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: DsmColor.ContentPrimary }, locationPickerCTA.text || "Find a Store")
  ), menuType && storeMenu && /* @__PURE__ */ React.createElement(Box, { display: menuType !== "store" ? "none" : void 0, className: classes.menuPositionWrapper }, /* @__PURE__ */ React.createElement(StoreMenu, { ...storeMenu, setMenuType, setIsOpenMobileMenu }))), favoritesCTA && /* @__PURE__ */ React.createElement(
    Coachmark,
    {
      target: /* @__PURE__ */ React.createElement(
        Flex,
        {
          component: "a",
          align: "center",
          gap: 5,
          "aria-label": "see favorites",
          textColor: DsmColor.ContentPrimary,
          ...omitFavoritesCTA(favoritesCTA).omitFavoritesCTA
        },
        /* @__PURE__ */ React.createElement(
          NotificationDot,
          {
            disabled: true,
            position: "top-end",
            borderColor: "var(--surface-neutral-medium-contrast)",
            withBorder: true,
            top: 7,
            right: 6,
            ...favoritesCTA.notificationDot
          },
          omitFavoritesCTA(favoritesCTA).isFilled ? /* @__PURE__ */ React.createElement(FavoriteNavFilledIcon, { withBoundingBox: true }) : /* @__PURE__ */ React.createElement(FavoriteNavIcon, { withBoundingBox: true })
        ),
        /* @__PURE__ */ React.createElement(Typography, { size: "navigation-s", component: "span", textColor: DsmColor.ContentPrimary }, favoritesCTA.text || "Favorites")
      ),
      disabled: !favoritesCTA.coachmark?.dropdown,
      variant: "highlight",
      size: "small",
      position: "right",
      withArrow: true,
      ...favoritesCTA.coachmark
    }
  )), languagePicker && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flex, { paddingBlock: 20, borderTop: "1px solid var(--border-tertiary)" }, /* @__PURE__ */ React.createElement(
    LanguagePicker,
    {
      ...languagePicker,
      languagePickerCTA: {
        ...getSanitizedLanguagePickerCTA(languagePicker),
        className: languagePicker.languagePickerCTA.className,
        onClick: (e) => {
          if (languagePicker?.languagePickerCTA && languagePicker?.languagePickerCTA?.onClick) {
            languagePicker?.languagePickerCTA?.onClick(e);
          }
        }
      },
      textColor: DsmColor.ContentPrimary
    }
  )), menuType && languageMenu && /* @__PURE__ */ React.createElement(Box, { display: menuType !== "language" ? "none" : void 0, className: classes.menuPositionWrapper }, /* @__PURE__ */ React.createElement(LanguageMenu, { ...languageMenu, setMenuType, setIsOpenMobileMenu }))));
});

export { UtilityBarMobile };
